import { useMemo, useState } from 'react';
import api from '../lib/api';

const SSO_SESSION_KEY = 'metani_sso_session';

const topics = [
  { value: 'bug', label: 'Bug' },
  { value: 'idea', label: 'Idee' },
  { value: 'ux', label: 'UX' },
  { value: 'pool', label: 'Pool' },
  { value: 'wallet', label: 'Wallet' },
];

const getSession = () => {
  try {
    const raw = window.sessionStorage.getItem(SSO_SESSION_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
};

export default function HuddyFeedback({ wallet }) {
  const [open, setOpen] = useState(false);
  const [topic, setTopic] = useState('ux');
  const [message, setMessage] = useState('');
  const [contact, setContact] = useState('');
  const [status, setStatus] = useState({ tone: 'idle', text: '' });
  const [submitting, setSubmitting] = useState(false);

  const session = useMemo(getSession, [open]);
  const address = wallet?.account || wallet?.address || session?.address || session?.user?.address || '';
  const pseudo = session?.pseudo || session?.user?.pseudo || '';

  const submit = async (event) => {
    event.preventDefault();
    const cleanMessage = message.trim();

    if (cleanMessage.length < 8) {
      setStatus({ tone: 'error', text: 'Message trop court.' });
      return;
    }

    setSubmitting(true);
    setStatus({ tone: 'idle', text: '' });

    try {
      await api.feedback.submit({
        topic,
        message: cleanMessage,
        contact: contact.trim(),
        pseudo,
        address,
        app: 'HudLife',
        page: window.location.pathname,
        userAgent: window.navigator.userAgent,
      });
      setMessage('');
      setContact('');
      setStatus({ tone: 'success', text: 'Feedback envoye.' });
    } catch (error) {
      setStatus({
        tone: 'error',
        text: error?.response?.data?.error || error?.message || 'Envoi impossible.',
      });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="fixed bottom-4 right-4 z-50 flex max-w-[calc(100vw-2rem)] flex-col items-end gap-3">
      {open ? (
        <form
          className="w-[min(24rem,calc(100vw-2rem))] rounded-2xl border border-cyan-400/25 bg-slate-950/95 p-4 shadow-2xl shadow-black/40 backdrop-blur"
          onSubmit={submit}
        >
          <div className="flex items-start justify-between gap-4">
            <div>
              <div className="text-sm font-semibold text-white">Huddy feedback</div>
              <div className="text-xs text-slate-400">{pseudo || address ? pseudo || address : 'Invite'}</div>
            </div>
            <button
              type="button"
              className="h-8 w-8 rounded-full border border-white/10 text-slate-300 transition hover:bg-white/10"
              onClick={() => setOpen(false)}
              aria-label="Fermer le feedback"
            >
              x
            </button>
          </div>

          <div className="mt-4 grid grid-cols-5 gap-2">
            {topics.map((item) => (
              <button
                key={item.value}
                type="button"
                className={`rounded-full border px-2 py-1 text-xs font-semibold transition ${
                  topic === item.value
                    ? 'border-cyan-300 bg-cyan-300 text-slate-950'
                    : 'border-white/10 bg-white/5 text-slate-300 hover:bg-white/10'
                }`}
                onClick={() => setTopic(item.value)}
              >
                {item.label}
              </button>
            ))}
          </div>

          <label className="mt-4 block text-sm text-slate-300" htmlFor="huddy-feedback-message">
            Message
          </label>
          <textarea
            id="huddy-feedback-message"
            className="mt-2 min-h-28 w-full resize-y rounded-xl border border-white/10 bg-white/5 px-3 py-2 text-sm text-white outline-none placeholder:text-slate-500 focus:border-cyan-300"
            maxLength={1200}
            value={message}
            onChange={(event) => setMessage(event.target.value)}
            placeholder="Ce qui bloque, ce qui manque, ce qui devrait evoluer..."
          />

          <label className="mt-3 block text-sm text-slate-300" htmlFor="huddy-feedback-contact">
            Contact
          </label>
          <input
            id="huddy-feedback-contact"
            className="mt-2 w-full rounded-xl border border-white/10 bg-white/5 px-3 py-2 text-sm text-white outline-none placeholder:text-slate-500 focus:border-cyan-300"
            maxLength={160}
            value={contact}
            onChange={(event) => setContact(event.target.value)}
            placeholder="Email, pseudo, wallet"
          />

          {status.text ? (
            <div
              className={`mt-3 rounded-xl border px-3 py-2 text-sm ${
                status.tone === 'success'
                  ? 'border-emerald-400/30 bg-emerald-400/10 text-emerald-200'
                  : 'border-rose-400/30 bg-rose-400/10 text-rose-200'
              }`}
            >
              {status.text}
            </div>
          ) : null}

          <button
            type="submit"
            className="mt-4 w-full rounded-xl bg-cyan-300 px-4 py-2 text-sm font-semibold text-slate-950 transition hover:bg-cyan-200 disabled:cursor-not-allowed disabled:opacity-60"
            disabled={submitting}
          >
            {submitting ? 'Envoi...' : 'Envoyer'}
          </button>
        </form>
      ) : null}

      <button
        type="button"
        className="h-12 rounded-full border border-cyan-300/40 bg-cyan-300 px-5 text-sm font-bold text-slate-950 shadow-xl shadow-cyan-950/40 transition hover:bg-cyan-200"
        onClick={() => setOpen((value) => !value)}
        aria-label="Ouvrir Huddy feedback"
      >
        Huddy
      </button>
    </div>
  );
}
